import type { PropsWithChildren } from 'react'

import type { Props as InputProps } from '#/global/component/Form/Input'
import { InputFormat } from '#/global/component/Form/InputFormat'

export const PhoneNumber = (props: PropsWithChildren<InputProps>) => <InputFormat format="+### ### ### ###" type="tel" {...props} />
